import { styled } from '@mui/material/styles';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '15px',
    borderRadius: 'var(--payment-component-shared-border-radius)',
    color: '#fff',
    backgroundColor: theme.palette.brandSecondary.mainCustom,
    cursor: 'pointer',
  };
});

export const StyledInfoIcon = styled(InfoOutlined)({
  display: 'flex',
  marginRight: '8px',
});
